// comment
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { DebugBox, plural } from "@northpowerdev/np-react-utils";
import { mahiBffUrl } from "../../../data/hikoFetch";
import UpdatedGalleryViewer from "../../upload/UpdatedGalleryViewer";

const bffBaseUrl = mahiBffUrl()
/**
 * 
 * @param {object} props E.g. {
 *  trprReference: {string} E.g. TRPR14675
 *  treeDocsDetails: {DocumentMeta[]} Defined in Types.js in np-react-utils library
 *  sx: {object}
 * }
 * @returns JSX
 */
export default function VegShowTreeDocs({trprReference, treeDocsDetails, sx}) {
    const borderSx ={
        border:0.5,
        borderRadius:1,
        borderColor:'#e0e0e0',
        p:0.5,
        height:'100%',
        boxShadow: '0px 0px 16px -3px rgba(0,0,0,0.2)'
       }
    console.log("Border Styling: ", borderSx)
    return (
        <Box>
            <Typography variant="body2">We found {treeDocsDetails.length} document{plural(treeDocsDetails.length)}.</Typography>
            <UpdatedGalleryViewer documents={treeDocsDetails} bffBase={bffBaseUrl} />
            <DebugBox title="treeDocsDetails" stringify>{treeDocsDetails}</DebugBox>
            <DebugBox title="Styling" stringify>{borderSx}</DebugBox>
        </Box>
    )
}